import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasClusterError } from '../../sections/types/BaasClusterError';
import { Cluster } from '../../sections/types/Cluster';

export interface ICreateBaasClusterParams {
  displayName: string;
}

export interface ICreateBaasClusterResult extends IResult {
  success?: {
    cluster: Cluster;
  };
  error?: BaasClusterError;
}

export class CreateBaasClusterRequest extends Request<ICreateBaasClusterParams, ICreateBaasClusterResult> {
  constructor(params: ICreateBaasClusterParams) {
    super('createBaasCluster', params);
  }
}
